<template>
  <emd-card>
    <emd-card-header>
      <emd-text size="section">
        {{ $t('title') }}
      </emd-text>
    </emd-card-header>
    <emd-card-content class="card">
      <div class="content">
        <div class="image">
          <img
            :src="
              require(`@/assets/recipients-biometry/roller-guy.svg`).default
            "
          />
        </div>
        <jade-text
          class="feedback"
          variant="heading-medium"
        >
          {{ $t('feedback') }}
        </jade-text>

        <jade-text
          class="description"
          variant="text-medium"
        >
          {{ $t('description-1', { name }) }}
          <b>{{ $t('description-2') }}</b>
          {{ $t('description-3') }}
        </jade-text>

        <jade-alert
          v-if="error"
          class="alert"
          variant="negative"
          show-icon
        >
          <jade-text color="negative">
            {{ $t('error-alert') }}
          </jade-text>
        </jade-alert>

        <generate-link-button
          :id="id"
          @error="handleGenerateLinkError"
          @generating="handleGenerating"
        >
          <template #trail>
            <jade-button
              class="button"
              size="medium"
              variant="primary-ghost"
              @click="redirectToDetails"
            >
              {{ $t('validate-later') }}
            </jade-button>
          </template>
        </generate-link-button>
      </div>
    </emd-card-content>
  </emd-card>
</template>

<script>
import JadeText from '@jade/JadeText'
import JadeButton from '@jade/JadeButton'
import JadeAlert from '@jade/JadeAlert'
import {
  EmdCard,
  EmdCardHeader,
  EmdCardContent,
  EmdText
} from 'emerald-vue/src/components'

export default {
  name: 'RecipientsBiometry',
  components: {
    EmdCard,
    EmdCardHeader,
    EmdCardContent,
    EmdText,
    JadeButton,
    JadeText,
    JadeAlert,
    GenerateLinkButton: () => import('./GenerateLinkButton.vue')
  },
  data () {
    return {
      error: false
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    redirectToDetails () {
      const { merchant_id: merchantId, account_id: accountId } =
        this.$route.params
      this.$router.push({
        path: `/${merchantId}/${accountId}/${this.id}/recipient-details`
      })
    },
    handleGenerateLinkError () {
      this.error = true
    },
    handleGenerating () {
      this.error = false
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 470px;
  flex-direction: column;
  padding: var(--global-space-500);
}

.image {
  margin-bottom: var(--global-space-500);
}

.feedback {
  text-wrap: nowrap;
  margin-bottom: var(--global-space-300);
}

.description {
  margin-bottom: var(--global-space-300);
}

.button {
  margin-right: var(--global-space-300);
}
.alert {
  margin-bottom: var(--global-space-300);
  width: 480px;
}
</style>

<i18n>
  {
    "pt-BR": {
      "title": "Validação",
      "feedback": "Recebedor adicionado e pronto para validação",
      "description-1": "Agora, crie e envie um link para o recebedor {name} liberar a ",
      "description-2": "movimentação do saldo.",
      "description-3": "Avise antes de enviar, o link é válido por 20 minutos!",
      "validate-later": "Validar depois",
      "error-alert": "Não foi possível criar o link. Tente outra vez."
    },
    "en-US": {
      "title": "Validation",
      "feedback": "Recipient created and ready for validation.",
      "description-1": "Now, generate and send the link to the recipient named {name} so he can ",
      "description-2": "unfreeze his account balance.",
      "description-3": "Befere you send it, the link is valid for 20 minutes!",
      "validate-later": "Validate later",
      "error-alert": "There was an error generating your link. Try again."
    }
  }
</i18n>
